var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent
